import type { ReactNode } from 'react';

export type MetricTone = 'default' | 'success' | 'warning' | 'info' | 'danger';

interface MetricTileProps {
  readonly label: string;
  readonly value: ReactNode;
  /** Optional secondary line under the value. */
  readonly hint?: string;
  /** Colours the value (and icon) to signal state, e.g. warning for shortfalls. */
  readonly tone?: MetricTone;
  /** Optional icon, shown top-right of the tile. */
  readonly icon?: ReactNode;
}

/** A single dense key figure. Use inside the `metrics` slot of {@link WorkspacePage}. */
export function MetricTile({ label, value, hint, tone = 'default', icon }: MetricTileProps) {
  return (
    <article className={`forq-metric-tile forq-metric-tile--${tone}`}>
      <div className="forq-metric-tile__top">
        <span className="forq-metric-tile__label">{label}</span>
        {icon ? <span className="forq-metric-tile__icon" aria-hidden="true">{icon}</span> : null}
      </div>
      <strong className="forq-metric-tile__value">{value}</strong>
      {hint ? <small className="forq-metric-tile__hint">{hint}</small> : null}
    </article>
  );
}
